import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import * as actionCreators from '../actions/app';
import { connect } from 'react-redux';
import { DateRangePicker } from 'react-dates';
import momentJalaali from 'moment-jalaali';

import 'react-dates/lib/css/_datepicker.css';

momentJalaali.locale('fa');
momentJalaali.loadPersian({usePersianDigits: true, dialect: 'persian-modern'})

class Rangecalendar extends Component {
  state = {
    startDate: this.props.initDate ? momentJalaali(this.props.initDate.startDate) : momentJalaali(this.props.report.paginationConfig.query.start),
    endDate: this.props.initDate ? momentJalaali(this.props.initDate.endDate) : momentJalaali(this.props.report.paginationConfig.query.end),
  }
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange = ({ startDate, endDate }) => {
    if(startDate)startDate = momentJalaali(startDate)
    if(this.state.focusedInput === 'endDate' && endDate)endDate = momentJalaali(endDate)
    else endDate = momentJalaali(startDate);
    this.setState({ startDate, endDate })
    if(this.props.onDatesChange) this.props.onDatesChange({ startDate, endDate });
  }

  render() {
    
      return (
        <div>
          <DateRangePicker
            isOutsideRange={() => false}
            startDatePlaceholderText="تاریخ شروع"
            endDatePlaceholderText="تاریخ پایان"
            isRTL = {true}
            hideKeyboardShortcutsPanel = {true}
            startDate={this.state.startDate} // momentPropTypes.momentObj or null,
            startDateId='dfsdfsf'
            endDate={this.state.endDate} // momentPropTypes.momentObj or null,
            endDateId='sdfsdfs'
            onDatesChange={({ startDate, endDate }) => this.handleChange({ startDate, endDate })} // PropTypes.func.isRequired,
            focusedInput={this.state.focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
            onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
            renderMonth={month => momentJalaali(month).format('jMMMM jYYYY')}
            renderDayContents={day => momentJalaali(day).format('jD')}
            anchorDirection="left"
            firstDayOfWeek={6}
            displayFormat="jD  jMMMM"
            readOnly={true}
          />
        </div>
      );
    
  }
}

function mapStateToProps(state) {
  return {
    app: state.app,
    report: state.report
  }
}

function mapDispachToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispachToProps)(Rangecalendar);